// extracted by mini-css-extract-plugin
export default {"viewwrapper":"TemporaryFileViewer_viewwrapper__nJqEw","iframeviewer":"TemporaryFileViewer_iframeviewer__LLjUX"};